module.exports = __webpack_public_path__ + "img/W-S17.6b1d5804.jpg";